import { render, staticRenderFns } from "./pointModuleShopList.vue?vue&type=template&id=478397e5&scoped=true"
import script from "./pointModuleShopList.vue?vue&type=script&lang=js"
export * from "./pointModuleShopList.vue?vue&type=script&lang=js"
import style0 from "./pointModuleShopList.vue?vue&type=style&index=0&id=478397e5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478397e5",
  null
  
)

export default component.exports